
// ROUTES
require('modules/tools/routes/tools');

// CONTROLLERS
require('modules/tools/controllers/tools');
require('modules/tools/controllers/list');
require('modules/tools/controllers/qrcode');

// SERVICES
require('modules/tools/services/tools');
require('modules/tools/services/qrcode');

angular.module('unica_tools', [

	// ROUTES
	'unica_tools.tools_routes',

	// CONTROLLERS
	'unica_tools.tools_controllers',

	// SERVICES
	'unica_tools.tools_services'

]);